import { DividerV2 } from "~/widgets/divider";
import HubbleImage from "~/widgets/hubble_image";

function DenominationGridHeaderTd(props: {
  brandTitle: string;
  brandLogoUrl: string;
}) {
  return (
    <div class="flex w-full flex-col items-start justify-start  px-4 lg:px-6">
      <span class="mt-4 text-[12px] font-normal text-basePrimaryDark">
        Exclusive offer on your NeuCard
      </span>
      <div class="mt-3"></div>
      <div class="h-px w-full darkTheme:bg-baseTertiaryDark dark:bg-basePrimaryMedium">
        &nbsp;
      </div>{" "}
      <div class="mt-4"></div>
      <div class="inline-flex flex-row items-start justify-between self-stretch ">
        <div class="inline-flex flex-col items-start justify-start">
          <div class=" text-h5 font-semibold leading-relaxed text-textDark lg:text-h3">
            Gift Card value
          </div>
          <div class="text-medium text-baseSecondaryMedium">
            Your shopping amount
          </div>
        </div>
        <div class="relative h-11 w-11 rounded-[50%] lg:h-[52px] lg:w-[52px]">
          <HubbleImage
            src={props.brandLogoUrl}
            class="h-full w-full rounded-full border border-neutral-200 object-cover darkTheme:border-baseTertiaryDark "
            alt={`${props.brandTitle}'s logo url`}
          />
        </div>
      </div>
    </div>
  );
}

export default DenominationGridHeaderTd;
